import { Dimensions } from 'react-native'
import { getCustomerColumnWidths } from '../helpers/getCustomerColumnWidths'
import { IColumn } from '../types/column'
import { OrderStatesEnum } from './order'

export enum StationTypesEnum {
    KITCHEN_STATION = 'kitchen',
    PICKER_STATION = 'picker',
    CUSTOMER_STATION = 'customer',
    MANAGER_STATION = 'manager',
}

export enum StationColumnIds {
    KITCHEN_NEW = 'kitchen_new',
    KITCHEN_IN_PROCESS = 'kitchen_in_process',
    KITCHEN_COOKED = 'kitchen_cooked',
    KITCHEN_CANCELLED = 'kitchen_cancelled',
    PICKER_NEW = 'picker_new',
    PICKER_IN_PROCESS = 'picker_in_process',
    PICKER_COOKED = 'picker_cooked',
    PICKER_ASSEMBLED = 'picker_assembled',
    PICKER_DELIVERING = 'picker_delivering',
    PICKER_FINISHED = 'picker_finished',
    PICKER_CANCELLED = 'picker_cancelled',
    CUSTOMER_IN_PROCESS = 'customer_in_process',
    CUSTOMER_COOKED = 'customer_cooked',
}

type StationColumns = {
    [key in StationTypesEnum]: {
        active: IColumn[]
        archive?: IColumn[]
    }
}

export const stationColumns: StationColumns = {
    [StationTypesEnum.KITCHEN_STATION]: {
        active: [
            {
                id: StationColumnIds.KITCHEN_NEW,
                name: 'Nové',
                stationStates: [OrderStatesEnum.NEW],
                states: [
                    OrderStatesEnum.NEW,
                    OrderStatesEnum.QUEUED_FOR_PROCESSING,
                    OrderStatesEnum.IN_PROCESS,
                ],
            },
            {
                id: StationColumnIds.KITCHEN_IN_PROCESS,
                name: 'V přípravě',
                stationStates: [OrderStatesEnum.IN_PROCESS],
                states: [OrderStatesEnum.IN_PROCESS],
            },
        ],
        archive: [
            {
                id: StationColumnIds.KITCHEN_COOKED,
                name: 'Jídlo je připraveno',
                stationStates: [OrderStatesEnum.COOKED],
                states: [
                    OrderStatesEnum.IN_PROCESS,
                    OrderStatesEnum.COOKED,
                    OrderStatesEnum.ASSEMBLED,
                    OrderStatesEnum.DELIVERING,
                    OrderStatesEnum.FINISHED,
                ],
            },
            {
                id: StationColumnIds.KITCHEN_CANCELLED,
                name: 'Stornováno',
                stationStates: [
                    OrderStatesEnum.NEW,
                    OrderStatesEnum.IN_PROCESS,
                    OrderStatesEnum.COOKED,
                ],
                states: [
                    OrderStatesEnum.ANNULLED,
                    OrderStatesEnum.CANCELLED,
                    OrderStatesEnum.REFUNDED,
                    OrderStatesEnum.UNDELIVERED,
                ],
            },
        ],
    },
    [StationTypesEnum.PICKER_STATION]: {
        active: [
            {
                id: StationColumnIds.PICKER_NEW,
                name: 'Nové',
                stationStates: [OrderStatesEnum.NEW, OrderStatesEnum.COOKED],
                states: [
                    OrderStatesEnum.NEW,
                    OrderStatesEnum.QUEUED_FOR_PROCESSING,
                    OrderStatesEnum.IN_PROCESS,
                ],
            },
            {
                id: StationColumnIds.PICKER_IN_PROCESS,
                name: 'V přípravě',
                stationStates: [OrderStatesEnum.IN_PROCESS, OrderStatesEnum.COOKED],
                states: [OrderStatesEnum.IN_PROCESS],
            },
            {
                id: StationColumnIds.PICKER_COOKED,
                name: 'Jídlo je připraveno',
                states: [OrderStatesEnum.COOKED],
            },
            {
                id: StationColumnIds.PICKER_ASSEMBLED,
                name: 'Nachystáno k předání',
                states: [OrderStatesEnum.ASSEMBLED],
            },
        ],
        archive: [
            {
                id: StationColumnIds.PICKER_DELIVERING,
                name: 'Doručované',
                states: [OrderStatesEnum.DELIVERING],
            },
            {
                id: StationColumnIds.PICKER_FINISHED,
                name: 'Doručené',
                states: [OrderStatesEnum.FINISHED],
            },
            {
                id: StationColumnIds.PICKER_CANCELLED,
                name: 'Stornováno',
                stationStates: [
                    OrderStatesEnum.NEW,
                    OrderStatesEnum.IN_PROCESS,
                    OrderStatesEnum.COOKED,
                ],
                states: [
                    OrderStatesEnum.ANNULLED,
                    OrderStatesEnum.CANCELLED,
                    OrderStatesEnum.REFUNDED,
                    OrderStatesEnum.UNDELIVERED,
                ],
            },
        ],
    },
    [StationTypesEnum.CUSTOMER_STATION]: {
        active: [
            {
                id: StationColumnIds.CUSTOMER_IN_PROCESS,
                name: 'Připravuje se',
                states: [
                    OrderStatesEnum.QUEUED_FOR_PROCESSING,
                    OrderStatesEnum.IN_PROCESS,
                    OrderStatesEnum.COOKED,
                ],
                width: getCustomerColumnWidths(Dimensions.get('window').width).firstColumnWidth,
            },
            {
                id: StationColumnIds.CUSTOMER_COOKED,
                name: 'Hotovo',
                states: [OrderStatesEnum.ASSEMBLED],
                width: getCustomerColumnWidths(Dimensions.get('window').width).secondColumnWidth,
            },
        ],
    },
    [StationTypesEnum.MANAGER_STATION]: {
        active: [],
    },
}

export const customerStation = {
    code: StationTypesEnum.CUSTOMER_STATION,
    id: StationTypesEnum.CUSTOMER_STATION,
    name: 'Zákazník',
    type: StationTypesEnum.CUSTOMER_STATION,
}
